var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"error-page"},[_c('div',{staticClass:"error-content"},[_c('div',{staticClass:"content-wrapper"},[_c('van-icon',{staticClass:"error-icon",attrs:{"name":"warning-o"}}),_c('h1',{staticClass:"error-title"},[_vm._v("页面未找到")]),_c('p',{staticClass:"error-message"},[_vm._v("抱歉，您访问的页面不存在")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }